import { theme } from '@chakra-ui/react'

export default {
  mono: `Poppins, ${theme.fonts?.mono}`,
  heading: `Poppins, ${theme.fonts?.heading}`,
  body: `Poppins, ${theme.fonts?.body}`,
}
